export default __webpack_public_path__ + "static/media/element_35.7ebaaee7.jpg";